import styled from 'styled-components'
import { css, media, innerBackground, radiuses, colors, fonts } from 'styles'
import UserThumbHorizontal from 'components/UserThumb/UserThumbHorizontal/StyledUserThumbHorizontal'
import Button from 'components/Button/StyledButton'
import Checkbox from 'components/Controls/Checkbox/StyledCheckbox'

// const innerBackgroundSimple = p => highlight(0.05, p.theme.colors.mainBackground);

const StyledUpgrade = styled.main`
  width: 100rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  font-size: 1.8rem;
  margin-top: 5rem;
  padding-bottom: 2rem;
  background-color: ${innerBackground};
  color: ${colors.textMain};
  border-radius: ${radiuses.large};
  overflow: hidden;
  text-align: center;
  ${({ vipEnabled }) =>
    vipEnabled &&
    css`
      width: 110rem;
      flex-flow: row nowrap;
      align-items: flex-start;
      justify-content: space-around;
      background-color: transparent;
      padding: 0 2rem;
      & > * {
        width: 45%;
      }
    `}

  .step-vip {
    padding: 3rem 0;
  }
  ${Checkbox} {
    font-weight: bold;
  }

  .user {
    color: ${colors.textMain};
  }
  .meta .text {
    background-color: ${innerBackground};
  }

  .title {
    padding: 1rem;
    font: 700 2.2rem ${fonts.title};
    color: ${colors.textSectionTitle};
  }
  .always-secure {
    max-width: 64rem;
    font-size: 1.4rem;
    padding: 1rem;
    margin: 1rem auto 0;
    img {
      max-width: 8rem;
    }
  }
  .call-center {
    margin: 1rem auto 0;
    font-size: 1.6rem;
    padding: 1rem;
  }

  .proceed {
    display: flex;
    justify-content: space-around;

    ${Button} {
      padding: 1rem 2rem;
      font-weight: 700;
    }
  }

  ${media.mobile`
    ${({ vipEnabled }) =>
      vipEnabled &&
      css`
        flex-direction: column;
        & > * {
          width: 100%;
        }
      `}
    padding-bottom: 5rem;

    .inner {
      min-width: auto;
      padding: 4rem 2rem;
    }
  `}

  ${media.phone`
    .inner {
      padding: 2rem 1rem;
    }
    .title {
      display: none;
    }
  `}
`

const UpgradeReason = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 6rem;
  background: ${colors.main};
  color: ${colors.mainInverted};
  ${({ vipEnabled }) =>
    vipEnabled &&
    css`
      padding: 1rem 2rem;
      border-radius: ${radiuses.large};
    `}

  .user {
    margin-right: 2rem;
    text-align: left;
  }

  .description {
    margin: 0;
    text-align: center;

    .attempted-action {
      display: block;
      margin-bottom: 0.5rem;
      font-weight: 700;
    }
  }

  ${UserThumbHorizontal} {
    background-color: ${colors.mainBackground};
    border-radius: ${radiuses.large};
    box-shadow: 0 0.2rem 0.5rem ${colors.boxShadow};

    .inner {
      padding: 0.5rem;
    }

    .avatar {
      margin: 0.5rem;
    }

    .city,
    .country {
      color: ${colors.textSecondary};
    }
  }

  ${media.mobile`
    flex-direction: column-reverse;
    padding: 2rem 2.5rem;
    box-sizing: border-box;
    border-radius: ${radiuses.large};

    .user {
      margin: 2rem auto 1rem;

      ${UserThumbHorizontal} {
        margin-right: 0rem;
        max-width: 30rem;
      }
    }
  `}
`

export default StyledUpgrade
export { UpgradeReason }
